import EmptyContent from './empty-content.vue';

export default EmptyContent;
